// extracted by mini-css-extract-plugin
module.exports = {"article":"articleContent_article__wvxkG"};